import React, { ReactNode } from 'react';
import { CreateSocialItem } from './CreateSocialItem';
import { User } from 'js/social/UserCard';
import { ResourcePayload, Comment } from 'js/social/shared/types';
import { ImpressionProps } from 'js/utils/impressions';

export const CreateReply = ({
  commentId,
  author,
  replyTo,
  onClose,
  onSubmit,
  depth,
  parentComment,
  impressionPropsGen,
}: {
  commentId: string | number;
  author: User;
  replyTo: {
    node: ReactNode;
    profileImg: ReactNode;
  };
  onClose(): void;
  onSubmit(payload: ResourcePayload): void;
  depth: number;
  parentComment: Comment;
  impressionPropsGen: (
    element?: string,
  ) => (clickTarget?: string) => ImpressionProps;
}) => {
  return (
    <CreateSocialItem
      id={`reply-${commentId}`}
      author={author}
      replyTo={replyTo}
      initialContent={depth > 1 ? ' ' : ''}
      initialTags={
        depth > 1
          ? [{ location: 0, tagId: parentComment.userId, tagType: 'user' }]
          : undefined
      }
      placeholder="Post your reply..."
      submitButtonText="Reply"
      allowAttachments={false}
      onClose={onClose}
      onSubmit={onSubmit}
      impressionPropsGen={impressionPropsGen('comment-modal')}
    />
  );
};
